module.exports = ":host .u-radio {\n  min-width: 100px; }\n"